var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{staticClass:"header",staticStyle:{"height":"162px"}},[_c('SelfHeader')],1),_c('el-main',{staticClass:"main"},[_c('router-view')],1),_c('el-footer',[_c('self-Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }